import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthStateService } from '../states/auth-state.service';

/** Solo alumnos entran al área de alumno; el resto se va a su sitio. */
export const studentGuard: CanActivateFn = () => {
  const auth = inject(AuthStateService);
  const router = inject(Router);

  if (!auth.isLoggedIn()) {
    router.navigate(['login']);
    return false;
  }
  if (!auth.isStudent()) {
    router.navigate(['/dashboard']);
    return false;
  }
  return true;
};
